import React, { ComponentProps, useCallback, useContext, useMemo } from 'react'

import TextButton from 'components/Luxkit/Button/TextButton'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useAppSelector } from 'hooks/reduxHooks'
import offerPageURL from 'lib/offer/offerPageURL'
import { getCurrentUserId } from 'selectors/accountSelectors'
import { BOOKING_DETAILS_COPY, VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import useOffer from 'hooks/Offers/useOffer'
import { TripItem } from 'tripPlanner/types/tripItem'
import {
  buildMyEscapesOrderLink,
  isLeBooking,
} from 'tripPlanner/utils'
import { addTripIdParam } from 'tripPlanner/utils/url'

interface Props {
  item: TripItem
  size?: ComponentProps<typeof TextButton>['size']
}

export default function BookedOfferDetailsCTA({
  item,
  size = 'medium',
}: Props) {
  const { tripId } = item
  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit ?? false
  const viewAsTemplate = tripContext?.viewAsTemplate
  const currentUserId = useAppSelector(getCurrentUserId)
  const isItemOwner = currentUserId === item.createdBy
  const [offer] = useOffer('code' in item ? item.code : undefined)
  const modalElement = useModalElementContext()

  const offerLink = useMemo(() => {
    if (!offer) return undefined
    return offerPageURL(offer)
  }, [offer])

  const myEscapesLink =
    canEdit && !viewAsTemplate ? buildMyEscapesOrderLink(item) : undefined
  const viewBooking = useCallback(() => {
    modalElement.resolve()
  }, [modalElement])

  if (!isLeBooking(item)) return null

  if (isItemOwner && myEscapesLink) {
    return (
      <TextButton
        kind="secondary"
        size={size}
        variant="default"
        to={myEscapesLink}
        target="_blank"
        onClick={viewBooking}
      >
        {BOOKING_DETAILS_COPY}
      </TextButton>
    )
  } else if (offerLink) {
    return (
      <TextButton
        kind="secondary"
        size={size}
        variant="default"
        to={addTripIdParam(offerLink, tripId, canEdit)}
        target="_blank"
      >
        {VIEW_OFFER_COPY}
      </TextButton>
    )
  } else {
    return null
  }
}
